export default {"src":"/_next/static/media/icXWhite.c5b87195.svg","height":21,"width":22,"blurWidth":0,"blurHeight":0};